import { createDefaults } from '../../utils/createDefaults';
import { Pesaje } from '../Alimentacion-Pesaje/types';
import { MedioPagoConPlan } from '../Pago/types';
import { Siniestro } from '../Siniestro/types';

// ======================
// REQUEST
// ======================
type PetReq = {
  datos_mascota: PetForm_1;
  datos_pago: MedioPagoConPlan;
  codigo_vendedor?: string;
};

// ======================
// RESPONSE
// ======================
type Pet = {
  id: number;
  nombre: string;
  animal: Animal;
  raza: string;
  sexo: Sexo;
  fecha_nacimiento: string;
  color: string;
  descripcion: string;
  img_link?: string | null;
  siniestros: Siniestro[];
  poliza: string | null;
  compania?: string | null;
  fechaContratacion?: string | null;
  fecha_contratacion?: string | null;
  fechaCoberturaInicio?: string | null;
  fecha_cobertura_inicio?: string | null;
  historial_peso: Pesaje[];
  pesajes: Pesaje[];
  codigo?: string | null;
  created_at: string;
  updated_at: string;
};

type Sexo = 'M' | 'F';
export type Animal = 'Perro' | 'Gato';

export type RazaRes = {
  id: number;
  nombre: string;
  animal: string;
};
//

type PetForm_1 = {
  nombre: string;
  animal: string;
  raza: string;
  sexo: string;
  fecha_nacimiento: string;
  color: string;
  peso?: number;
  fechaPesaje?: string;
};

type PetForm_2 = {
  plan?: number;
};

type PetForm_3 = {
  nombreTitular: string;
  numeroTarjeta?: string;
  cbu?: string;
  vencimiento: string;
  tipo: string;
};

export const PetForm_1_Defaults = createDefaults<PetForm_1>({
  nombre: '',
  animal: '',
  raza: '',
  sexo: '',
  fecha_nacimiento: '',
  color: '',
  peso: undefined,
  fechaPesaje: undefined,
});

export const PetForm_2_Defaults = createDefaults({
  plan: undefined,
});

export const PetForm_3_Defaults = createDefaults({
  nombreTitular: '',
  numeroTarjeta: '',
  cbu: '',
  vencimiento: '',
  tipo: '',
});

type SolicitudCambioPetReq = {
  mascotaId: number | null;
  mascotaNombre: string | null;
  mascotaColor?: string | null;
  mascotaSexo: string | null;
  mascotaFechaNac: string | null;
  mascotaEspecie: string | null;
  mascotaRaza: string | null;
};

type ChangeCoverageReq = {
  mascotaId: number;
  planId: number;
  datosPagoId: number;
};

type SyncPet = {
  email: string;
};

type UpdatePicBody = { pic: string; petId: string };

export type {
  PetReq,
  Pet,
  PetForm_1,
  PetForm_2,
  PetForm_3,
  ChangeCoverageReq,
  SolicitudCambioPetReq,
  SyncPet,
  UpdatePicBody,
};
